import { Outlet } from "react-router-dom";

import { FilterMemberProvider } from "./filter-member/filter-member.context";
import './member.scss';

export function Member() {
  return (
    <div id="ShellMember" className="member">
       <FilterMemberProvider>
        <Outlet />
      </FilterMemberProvider>
    </div>
  );
}

export default Member;
